import { useLazyFetch, useLazyPost } from "../utils/apiclient";
import { simUrl } from "../utils/urls";
import { getHeaders } from "../utils/apiclient";

export const useListAllEngines = () => {
  return useLazyFetch(`${simUrl}/apps/tessell/software-images/db-engines`, {
    headers: { ...getHeaders(), Action: "LIST_ALL" },
  });
};

export const useListAllDbSoftware = (engine, releaseBranch) => {
  return useLazyFetch(
    `${simUrl}/apps/tessell/software-images/db-software?engine=${engine}&releaseBranch=${releaseBranch}`,
    {
      headers: { ...getHeaders(), Action: "LIST_ALL" },
    }
  );
};

export const useListAllOsSoftware = (engine, releaseBranch) => {
  return useLazyFetch(
    `${simUrl}/apps/tessell/software-images/os?engine=${engine}&releaseBranch=${releaseBranch}`,
    {
      headers: { ...getHeaders(), Action: "LIST_ALL" },
    }
  );
};

export const useListALLCommonScripts = (releaseBranch) => {
  return useLazyFetch(
    `${simUrl}/apps/tessell/software-images/scripts/common?releaseBranch=${releaseBranch}`,
    {
      headers: { ...getHeaders(), Action: "LIST_ALL" },
    }
  );
};

export const useSubmitDbSoftwareBuild = () => {
  return useLazyPost(
    `${simUrl}/apps/tessell/software-images/db-software/builds`,
    {
      headers: { ...getHeaders(), Action: "TRIGGER" },
      method: "POST",
    }
  );
};

export const useSubmitOsBuild = () => {
  return useLazyPost(`${simUrl}/apps/tessell/software-images/os/builds`, {
    headers: { ...getHeaders(), Action: "TRIGGER" },
    method: "POST",
  });
};

export const useListAllDbSoftwareBuilds = () => {
  return useLazyFetch(
    `${simUrl}/apps/tessell/software-images/db-software/builds`,
    {
      headers: { ...getHeaders(), Action: "LIST_ALL" },
    }
  );
};

export const useListAllOsImageBuilds = () => {
  return useLazyFetch(`${simUrl}/apps/tessell/software-images/os/builds`, {
    headers: { ...getHeaders(), Action: "LIST_ALL" },
  });
};

export const useDeleteDbSoftwareBuild = () => {
  return useLazyFetch(
    `${simUrl}/apps/tessell/software-images/db-software/builds/`,
    {
      headers: { ...getHeaders(), Action: "DELETE" },
      method: "DELETE",
    }
  );
};

export const useDeleteOsImageBuild = () => {
  return useLazyFetch(`${simUrl}/apps/tessell/software-images/os/builds/`, {
    headers: { ...getHeaders(), Action: "DELETE" },
    method: "DELETE",
  });
};

export const useRetryDbSoftwareBuild = () => {
  return useLazyPost(
    `${simUrl}/apps/tessell/software-images/db-software/builds/`,
    {
      headers: { ...getHeaders(), Action: "RETRY" },
      method: "POST",
    }
  );
};

export const useRetryOsImageBuild = () => {
  return useLazyPost(`${simUrl}/apps/tessell/software-images/os/builds/`, {
    headers: { ...getHeaders(), Action: "RETRY" },
    method: "POST",
  });
};

export const useReuploadDbSoftwareBuildScripts = (buildId) => {
  return useLazyPost(
    `${simUrl}/apps/tessell/software-images/db-software/builds/${buildId}`,
    {
      headers: { ...getHeaders(), Action: "REUPLOAD_SCRIPTS" },
      method: "PATCH",
    }
  );
};
